
import { ArrowRight, Coins } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

const MetalEstimationCTA = () => {
  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="bg-white rounded-xl shadow-md overflow-hidden">
          <div className="flex flex-col md:flex-row">
            <div className="md:w-2/5 bg-fabre-green p-8 flex items-center">
              <div className="text-white">
                <Coins className="h-12 w-12 mb-4" />
                <h2 className="text-2xl md:text-3xl font-heading font-bold mb-2">
                  Valorisez vos métaux
                </h2>
                <p className="text-white/90">
                  Nous rachetons vos ferrailles et métaux aux meilleurs prix du marché
                </p>
              </div>
            </div>
            
            <div className="md:w-3/5 p-6 md:p-12">
              <h3 className="text-xl md:text-2xl font-heading font-bold text-fabre-gray mb-4">
                Demandez une estimation pour vos ferrailles et métaux
              </h3>
              <p className="text-gray-600 mb-6">
                Vous disposez de métaux ferreux ou non-ferreux que vous souhaitez vendre ? 
                Groupe Fabre vous propose des tarifs attractifs pour la reprise de vos matériaux.
                Remplissez notre formulaire pour une estimation rapide et personnalisée.
              </p>
              <ul className="mb-6 space-y-2">
                <li className="flex items-start">
                  <span className="inline-flex items-center justify-center h-5 w-5 rounded-full bg-fabre-green text-white mr-2 text-xs">✓</span>
                  <span>Ferrailles, aluminium, cuivre, inox, laiton...</span>
                </li>
                <li className="flex items-start">
                  <span className="inline-flex items-center justify-center h-5 w-5 rounded-full bg-fabre-green text-white mr-2 text-xs">✓</span>
                  <span>Pesée certifiée sur balance homologuée</span>
                </li>
                <li className="flex items-start">
                  <span className="inline-flex items-center justify-center h-5 w-5 rounded-full bg-fabre-green text-white mr-2 text-xs">✓</span>
                  <span>Paiement sécurisé selon la réglementation</span>
                </li>
              </ul>
              <Button asChild className="bg-fabre-green hover:bg-fabre-darkgreen transition-colors">
                <Link to="/contact">
                  Demander une estimation
                  <ArrowRight className="ml-2 h-4 w-4" />
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MetalEstimationCTA;
